import { NgModule } from '@angular/core';
import { CalsoftMediaWatcherService } from './media-watcher.service';



@NgModule({
  providers: [
    CalsoftMediaWatcherService
  ]
})
export class CalsoftMediaWatcherModule {
  /**
   * Constructor
   *
   * @param {CalsoftMediaWatcherService} _calsoftMediaWatcherService
   */
  constructor(
    private _calsoftMediaWatcherService: CalsoftMediaWatcherService
  ) {
  }
}
